export default __webpack_public_path__ + "static/media/PopInAnniversaire.f3b93992.jpg";